module.exports = __webpack_public_path__ + "static/media/print-icon.5e2decdf.svg";